const firebaseConfig = {
  apiKey: 'AIzaSyD3KkVMXDx9SpidxUpYUTb2ePdntve63nc',
  authDomain: 'twdc-stag.firebaseapp.com',
  projectId: 'twdc-stag',
  storageBucket: 'twdc-stag.appspot.com',
  messagingSenderId: '711627715927',
  appId: '1:711627715927:web:0f09a6e7a2e1214643ba12',
};

export default firebaseConfig;
